import Product from "../../Components/Product/Product";
import "./Products.css";

import productImg1 from "../../Media/products/product1.jpg";
import productImg2 from "../../Media/products/product2.jpg";
import productImg3 from "../../Media/products/product3.jpg";


export default function Products() {
    return (
        <div className="products">
            <div className="productGrid">
                <Product
                    heading="Frühjahrsblütenhonig"
                    description="Eine „Melange“ vom Nektar vieler Obstarten vereint mit Löwenzahn, Raps, Schlehe, Weißdorn und vielem mehr..."
                    img={productImg1}
                />

                <Product
                    heading="Sonnenblumenhonig"
                    description="Schmelzend-cremige Konsistenz mit würziger Geschmacksnote"
                    img={productImg2}
                />

                <Product
                    heading="Akazienhonig"
                    description="Klarer Akazienhonig mit mildem Aroma"
                    img={productImg3}
                />
            </div>

            <p className="productsDescription">Alle Sorten erhältlich in 250g, 500g und 1kg</p>
        </div>
    );
}